import { cn } from "@/lib/cn";
import { forwardRef, type HTMLAttributes } from "react";
import { SurfaceProvider } from "./Surface";
import { useElementRef } from "./use-element-ref";

/** The frosted top-bar surface (card fading to 70%, blurred, bar shadow) shared by every sticky chrome bar. */
export const CHROME_BAR = "bg-gradient-to-b from-card to-card/70 backdrop-blur-lg shadow-bar";

/** Props of `ChromeBar`; `height="header"` matches `APP_HEADER_HEIGHT`, `className` positions it (sticky, fixed, z). */
export type ChromeBarProps = HTMLAttributes<HTMLElement> & {
  as?: "div" | "header" | "nav";
  height?: "header" | "auto";
};

/** Frosted bar over scrolling content (app menu, sticky item and category titles); text reads as card text. */
export const ChromeBar = forwardRef<HTMLElement, ChromeBarProps>(function ChromeBar(
  { as: Tag = "div", height = "header", className, children, ...rest },
  ref,
) {
  const elementRef = useElementRef(ref);
  return (
    <Tag
      {...rest}
      ref={elementRef}
      className={cn(CHROME_BAR, "text-card-text", height === "header" && "flex h-header items-center", className)}
    >
      <SurfaceProvider surface="card">{children}</SurfaceProvider>
    </Tag>
  );
});
